import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../lib/cn";

/**
 * Универсальный контейнер для унификации ширин и отступов
 * Заменяет все различные max-width и padding в приложении
 */
const LayoutContainer = ({
  children,
  size = "default",
  className = "",
  ...props
}) => {
  const sizes = {
    sm: "max-w-2xl", // 672px
    md: "max-w-4xl", // 896px
    lg: "max-w-6xl", // 1152px
    xl: "max-w-7xl", // 1280px
    compact: "max-w-[800px]", // Оптимальная ширина для контентных страниц
    full: "max-w-full",
    default: "max-w-6xl", // 1152px - наиболее частый случай
  };

  const containerClasses = cn(
    // Базовые классы
    "w-full mx-auto",
    // Адаптивные отступы - используем централизованную переменную на мобильных
    "px-[var(--mobile-content-padding)] sm:px-3 md:px-4 lg:px-6",
    // Размер контейнера
    sizes[size],
    // Дополнительные классы
    className,
  );

  return (
    <div className={containerClasses} {...props}>
      {children}
    </div>
  );
};

LayoutContainer.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl", "compact", "full", "default"]),
  className: PropTypes.string,
};

export default LayoutContainer;
